<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 20 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="black" height="21" width="20" y="3"/>
    <rect fill="#FFAD68" height="3" width="20"/>
    <path d="M7.64589 15.144C7.69571 15.8514 7.97469 16.3895 8.48285 16.7582C8.97107 17.1467 9.58384 17.341 10.3212 17.341C11.7161 17.341 12.4136 16.8628 12.4136 15.9062C12.4136 15.159 11.8406 14.6757 10.6948 14.4565L8.91627 14.1128C8.02949 13.9334 7.32207 13.5947 6.79399 13.0965C6.25594 12.5784 5.98692 11.9307 5.98692 11.1535C5.98692 9.88813 6.64951 8.97147 7.97469 8.40353C8.58248 8.13451 9.27995 8 10.0671 8C11.3424 8 12.3488 8.30888 13.0861 8.92663C13.8135 9.55435 14.207 10.3913 14.2668 11.4375H12.2342C12.2242 10.9094 12.025 10.486 11.6364 10.1671C11.2378 9.82835 10.6749 9.65897 9.94752 9.65897C9.35966 9.65897 8.87641 9.77355 8.49779 10.0027C8.12913 10.2518 7.9448 10.5806 7.9448 10.9891C7.9448 11.3578 8.08928 11.6418 8.37823 11.841C8.62732 12.0005 9.07071 12.1499 9.70839 12.2894L11.472 12.6332C13.4149 13.0118 14.3864 14.0082 14.3864 15.6223C14.3864 16.6286 14.0227 17.4357 13.2953 18.0435C12.558 18.6812 11.5367 19 10.2315 19C8.8266 19 7.73058 18.6513 6.94344 17.9538C6.13638 17.2663 5.69299 16.3297 5.61328 15.144H7.64589Z" fill="white"/>
  </svg>
</template>

<script>
export default {
  name: 'EyeAppealS',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
  },
};

</script>
